import { render, staticRenderFns } from "./WrapperTour.vue?vue&type=template&id=3929c114&scoped=true"
import script from "./WrapperTour.vue?vue&type=script&lang=js"
export * from "./WrapperTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3929c114",
  null
  
)

export default component.exports